<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listPhoneType"
        :title-table="$t('Phone Type')"
        module="phoneTypeSettingsModule"
        sort-name="nome"
        add-permission="ROLE_TIPO_FONE_INSERIR"
        view-permission="ROLE_TIPO_FONE_CONSULTAR"
        edit-permission="ROLE_TIPO_FONE_ATUALIZAR"
        delete-permission="ROLE_TIPO_FONE_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormPhoneType v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import FormPhoneType from "./forms/FormPhoneType.vue";

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormPhoneType,
  },
  computed: {
    ...mapState("phoneTypeSettingsModule", {
      listPhoneType: (state) => state.listPhoneType,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: "Descrição",
          field: "nome",
        },
        {
          label: "Ativo",
          field: "ativo",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch(
        "phoneTypeSettingsModule/prepareToEditPhoneType",
        data,
      );
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
